module.exports = __webpack_public_path__ + "static/media/Cloudberries.38b04b30.png";